import { keyframes } from '@emotion/react';

export const fadeIn = keyframes`
  0%,
  1% {
    opacity: 0;
    transform: translateY(-6px);
  }

  100% {
    opacity: 1;
    transform: none;
  }
`;
